import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';
import React from 'react';

const Text = styled.div`
  width: 100%;
  padding: 7px 16px;
  background: rgba(240, 247, 255, 1);
  border-radius: 2px;
  font-size: 12px;
`;
const ErrorText = styled.div`
  width: 100%;
  padding: 7px 16px;
  background: #fae6e6;
  border-radius: 2px;
  font-size: 12px;
  color: var(--ant-error-color);
`;

interface Props {
  showAuthError?: boolean;
  children?: React.ReactNode;
}

const Tips = (props: Props) => {
  const { showAuthError = false, children } = props;
  const { t } = useTranslate();
  if (showAuthError) {
    return <ErrorText>{t('ViewShops.shopee.auth.process.tips.error')}</ErrorText>;
  }
  if (children) {
    return <Text>{children}</Text>;
  }
  return <Text>{t('ViewShops.shopee.auth.process.tips.info')}</Text>;
};

export default Tips;
